import useGetReduxState from "../../../Hooks/useGetReduxState";

const Header = () => {
  const lang = useGetReduxState().behaviour.lang;
  return lang === "en" ? <div>Train Schedule</div> : <div>ट्रेन अनुसूची</div>;
};

export default Header;
